import { render, staticRenderFns } from "./controlGroup.vue?vue&type=template&id=0c482800"
import script from "./controlGroup.vue?vue&type=script&lang=js"
export * from "./controlGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c482800')) {
      api.createRecord('0c482800', component.options)
    } else {
      api.reload('0c482800', component.options)
    }
    module.hot.accept("./controlGroup.vue?vue&type=template&id=0c482800", function () {
      api.rerender('0c482800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/controlManage/groupFrom/controlGroup.vue"
export default component.exports